import { UserWithoutTeachers } from "@/types/users/userWithoutTeachers";
import { Teacher } from "./teacher";

export const getUsersQueryKey = () => ["users"] as const;

export const getUserQueryKey = (id?: number) =>
    ["user", id || "current"] as const;

export type User = UserWithoutTeachers & {
    current_teacher: Teacher | null;
    teachers: Teacher[];
};
